import type {
  InputHTMLAttributes,
  ReactNode,
  TextareaHTMLAttributes,
} from "react";
import { cn } from "../../lib/cn";

export function Field({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: ReactNode;
  children: ReactNode;
}) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-medium text-ink-muted">
        {label}
      </span>
      {children}
      {hint != null && (
        <span className="mt-1 block text-xs text-ink-faint">{hint}</span>
      )}
    </label>
  );
}

const base =
  "ring-focus w-full rounded-md border border-line bg-surface-1 px-3 py-2 text-sm text-ink placeholder:text-ink-faint";

export function TextInput({
  className,
  ...props
}: InputHTMLAttributes<HTMLInputElement>) {
  return <input className={cn(base, className)} {...props} />;
}

export function TextArea({
  className,
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea className={cn(base, "min-h-[80px] resize-y", className)} {...props} />
  );
}
